import de from 'date-fns/locale/de';
import en from 'date-fns/locale/en-GB';

const locales = {
  de,
  en
};

export default locales;
